export default "__VITE_ASSET__BOspOVhL__"